import { render } from "./TasksByDueDateChart.vue?vue&type=template&id=a8753014"
import script from "./TasksByDueDateChart.vue?vue&type=script&lang=js"
export * from "./TasksByDueDateChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__